import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
// import * as TemplateActions from "../../../../../template/src/store/template/action";
import * as TemplateActions from "@workspace/template/src/store/template/action";


function SubjectSelect({ category, setSubjectTemplate }) {
  const dispatch = useDispatch();
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const templatesByCategory = useSelector(
    (state) => state.TemplateReducer.templatesByCategory
  );
  const templatesByCategoryList = useSelector(
    (state) => state.TemplateReducer.templatesByCategoryList
  );

  useEffect(() => {
    if (category) {
      dispatch(TemplateActions.fetchTemplateByCategory(category));
      return;
    }
  }, [category]);

  useEffect(() => {
    if (templatesByCategoryList[category]) {
      const options = templatesByCategoryList[category]?.map((item) => {
        if (item.category !== category) return null;
        return {
          value: item,
          label: item.name,
        };
      });
      setSubjectOptions(options);
    }
  }, [templatesByCategoryList]);

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "#8AAED6" : "#d3d3d3",
      "&:hover": {
        borderColor: state.isFocused ? "#8AAED6" : "#d3d3d3",
      },
      backgroundColor: state.isDisabled ? "#EFF2F7" : base.backgroundColor,
      width: "300px",
      border: "none",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? "black !important" : provided.color,
    }),
  };

  const handleChange = (selected) => {
    setSelectedSubject(selected);
    setSubjectTemplate(selected);
    if (selected == null || selected === undefined || selected === "") {
      setSubjectTemplate(null);
    }
  };

  return (
    <div>
      <Select
        isClearable
        onChange={handleChange}
        styles={customStyles}
        placeholder="Select Subject Template"
        options={subjectOptions}
        value={selectedSubject}
      />
    </div>
  );
}

export default SubjectSelect;
